/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Docs_MdInputs */

const en_mcphosted_docs_md = /** @type {(inputs: Mcphosted_Docs_MdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`## 6. Bystep inside your chat app (hosted MCP)

Bystep runs an MCP server at \`https://bystep.dev/api/mcp\`. Add it as a **custom connector** and you can steer the Runner straight from Claude.ai, ChatGPT or Cursor — no terminal, no repo, no code in the chat.

### Sign in with your access key

Create a personal access key in Bystep (Settings → Access keys); it starts with \`bs_\`. Send it as the header \`Authorization: Bearer bs_…\`. When the chat app only asks for a URL, append it instead: \`https://bystep.dev/api/mcp?token=bs_…\`.

A key inside a URL can end up in browser history and proxy logs, so prefer the header, never paste that URL in public, and revoke the key if you do. Bystep does not speak OAuth 2.1 yet — that is why it is a **custom connector** and not (yet) a directory listing in Claude or ChatGPT.

### Add it

- **Claude.ai** — Settings → Connectors → **Add custom connector** → paste the URL (with \`?token=\`) → Connect. Custom connectors are available on paid plans.
- **ChatGPT** — Settings → Connectors → Advanced → **Developer mode** → Create → paste the URL → save, then pick the connector in the composer.
- **Cursor** — Settings → MCP → Add new MCP server → type \`http\`, URL \`https://bystep.dev/api/mcp\`, header \`Authorization: Bearer bs_…\`.

### The seven tools

\`list_plans\` · \`plan_status\` · \`run_next\` · \`run_status\` · \`preview_url\` · \`approve_stage\` · \`escalate\`.

They call the very same server the Bystep website calls, so your monthly steps, the stage gates and Proof-of-Done behave exactly as they do on the site. The chat itself never writes code: every tool starts Bystep's own Runner and hands you back a link.

### What it sounds like

- **You:** continue my salon project
- **Claude:** Salon Cantik is 4 of 12 steps done. Shall I build the next one — "Customers can pick a time"?
- **You:** yes please
- **Claude:** Started it. … Finished. Try it on your phone: https://salon-cantik.apps.bystep.dev
- **You:** works for me
- **Claude:** Stage 1 approved. Starting step 5…
`)
};

const id_mcphosted_docs_md = /** @type {(inputs: Mcphosted_Docs_MdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`## 6. Bystep di aplikasi chat-mu (MCP hosted)

Bystep menyediakan server MCP di \`https://bystep.dev/api/mcp\`. Pasang sebagai **konektor kustom**, lalu kamu bisa menyuruh Bystep membangun dari Claude.ai, ChatGPT, atau Cursor — tanpa terminal, tanpa repo, tanpa kode di dalam chat.

### Masuk dengan kunci aksesmu

Buat kunci akses pribadi di Bystep (Pengaturan → Kunci akses); awalannya \`bs_\`. Kirim sebagai header \`Authorization: Bearer bs_…\`. Kalau aplikasi chat hanya meminta URL, tempelkan di URL-nya: \`https://bystep.dev/api/mcp?token=bs_…\`.

Kunci di dalam URL bisa tercatat di riwayat browser dan log proxy. Jadi utamakan header, jangan tempel URL itu di tempat umum, dan cabut kuncinya kalau terlanjur. Bystep belum memakai OAuth 2.1 — itu sebabnya ini **konektor kustom**, belum masuk direktori resmi Claude atau ChatGPT.

### Cara memasang

- **Claude.ai** — Settings → Connectors → **Add custom connector** → tempel URL (pakai \`?token=\`) → Connect. Konektor kustom tersedia di paket berbayar.
- **ChatGPT** — Settings → Connectors → Advanced → **Developer mode** → Create → tempel URL → simpan, lalu pilih konektornya di kolom pesan.
- **Cursor** — Settings → MCP → Add new MCP server → tipe \`http\`, URL \`https://bystep.dev/api/mcp\`, header \`Authorization: Bearer bs_…\`.

### Tujuh alat yang tersedia

\`list_plans\` · \`plan_status\` · \`run_next\` · \`run_status\` · \`preview_url\` · \`approve_stage\` · \`escalate\`.

Semuanya memanggil server yang sama dengan yang dipakai situs Bystep, jadi jatah langkah bulanan, gerbang tahap, dan bukti hasil berlaku persis sama. Chat-nya sendiri tidak pernah menulis kode: setiap alat menyalakan Runner milik Bystep, lalu mengembalikan tautan.

### Kira-kira begini obrolannya

- **Kamu:** lanjutkan proyek salon saya
- **Claude:** Salon Cantik sudah 4 dari 12 langkah. Mau saya kerjakan langkah berikutnya — "Pelanggan bisa memilih jam"?
- **Kamu:** iya
- **Claude:** Sudah jalan. … Selesai. Coba di HP-mu: https://salon-cantik.apps.bystep.dev
- **Kamu:** sudah oke
- **Claude:** Tahap 1 disetujui. Mulai langkah ke-5…
`)
};

/**
* | output |
* | --- |
* | "## 6. Bystep inside your chat app (hosted MCP) Bystep runs an MCP server at `https://bystep.dev/api/mcp`. Add it as a **custom connector** and you can steer ..." |
*
* @param {Mcphosted_Docs_MdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_docs_md = /** @type {((inputs?: Mcphosted_Docs_MdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Docs_MdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_docs_md(inputs)
	return en_mcphosted_docs_md(inputs)
});